import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {LibraryEntry} from '../../models';

@Component({
    selector: 'app-item-risk-mitigation-tab',
    templateUrl: './item-risk-mitigation-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ItemRiskMitigationTabComponent {
    @Input() entry: LibraryEntry;
    @Input() libraryType: string;
    @Input() formGroup: UntypedFormGroup;

}
